/**
 * Findet das nächste Element in einem Array, das eine gegebene Bedingung erfüllt,
 * ausgehend von einem Startindex – mit Rundum-Suche (zyklisch).
 *
 * @param array - Das Array mit Elementen
 * @param startIndex - Der Index, ab dem die Suche beginnt
 * @param predicate - Die Bedingung, die erfüllt sein muss
 * @returns Das gefundene Element oder undefined, wenn keines passt
 */
export function findNextCyclic<T>(
  array: T[],
  startIndex: number,
  predicate: (item: T, index: number) => boolean
): T | undefined {
  if (array.length === 0) return undefined;

  // Wir starten am aktuellen Index und gehen bis zum Ende
  for (let i = startIndex; i < array.length; i++) {
    if (predicate(array[i], i)) return array[i];
  }

  // Wenn nichts gefunden wurde, von Anfang bis zum aktuellen Index-1 suchen
  for (let i = 0; i < startIndex; i++) {
    if (predicate(array[i], i)) return array[i];
  }

  // Nichts gefunden
  return undefined;
}